export default function SectionLabel({ children }) {
  return (
    <div className="flex items-center gap-3 mb-5">
      <span className="h-px w-10 bg-primary/60" />
      <span className="text-[11px] uppercase tracking-[0.32em] text-primary font-medium">{children}</span>
    </div>
  );
}
